// Import the functions you need from the SDKs you need
import type { GameID, KeyPlayer, Lv2Player, Lv2PlayerType, PlayerID, VideoID, PlayerFlag, IComment } from "@types";
import { EnabledFeatures } from "App";
import { initializeApp } from "firebase/app";
import { addDoc, collection, getDocs, getFirestore, onSnapshot, query, where, serverTimestamp, FieldValue } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FILEBASE_KEY,
  authDomain: process.env.REACT_APP_FILEBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FILEBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FILEBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FILEBASE_SENDER_ID,
  appId: process.env.REACT_APP_FILEBASE_APP_ID,
  measurementId: process.env.REACT_APP_FILEBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

interface DocComment {
  content: string
  gameId: GameID,
  videoId: VideoID,
  frameIdx: number
  pickedPlayers: {
    lv1: Partial<Record<PlayerID, KeyPlayer>>,
    lv2: Partial<Record<PlayerID, Lv2Player>>
  }
  features: EnabledFeatures
  playerFlag: Partial<Record<PlayerID, PlayerFlag>>
  ts?: FieldValue
}

const COLLECTION_NAME = 'comments'
export async function postComment(meta: DocComment) {
  try {

    const { pickedPlayers, ...rest } = meta
    const { lv1, lv2 } = pickedPlayers

    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...rest,
      pickedPlayers: {
        lv1,
        lv2: Object.entries(lv2)
          .reduce((o, [pId, v]) => {
            o[+pId as PlayerID] = {
              ...v,
              id: v.id,
              type: Array.from(v.type)
            }
            return o
          }, {} as Partial<Record<PlayerID, Omit<Lv2Player, 'type'> & { type: Lv2PlayerType[] }>>)
      },
      ts: serverTimestamp()
    })
    return docRef.id
  } catch (e) {
    console.error("Error adding document: ", e);
  }
}

export async function getComment() {
  const querySnapshot = await getDocs(collection(db, COLLECTION_NAME));

  // group by gameId+videoId+frameIdx, 
  const commentsGroupBy: Record<string, IComment[]> = {}
  querySnapshot.forEach((doc) => {
    const { content, gameId, videoId, frameIdx, ts } = doc.data() as DocComment
    // @ts-ignore, the filed from firebase
    const seconds = (ts?.seconds ?? 0) * 1000
    const key = `${gameId}_${videoId}_${frameIdx}`
    if (!(key in commentsGroupBy)) {
      commentsGroupBy[key] = []
    }
    commentsGroupBy[key].push({
      id: doc.id,
      content, gameId, videoId, frameIdx, ts: seconds
    })
  });

  // const comments: IComment[] = []
  // then orderByTime, limitByNum
  return Object.entries(commentsGroupBy)
    .flatMap(([key, commentsGroup]) => commentsGroup
      .sort((a, b) => a.ts! - b.ts!)
      // limit by num
      .filter((c, i) => i < 20)
    )
}


export function subscribe(cb: (comments: IComment[]) => void) {
  const q = query(collection(db, COLLECTION_NAME));
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const comments: IComment[] = []
    querySnapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        const { content, gameId, videoId, frameIdx } = change.doc.data() as DocComment

        comments.push({
          id: change.doc.id,
          content, gameId, videoId, frameIdx
        })
      }
    })
    cb(comments)
  });
  return unsubscribe
}


